import { createAction } from '@reduxjs/toolkit';

import type { PartnerData as Partner } from '@/components/b2b/shared/types';
import type { PartnerData as DTCPartner } from '@/components/dtcPartnerships/shared/types';

import { SET_PARTNER } from './types';

export const setPartner = createAction<Partner | DTCPartner, typeof SET_PARTNER>(SET_PARTNER);
